import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth-store'
import { ResetPassword } from '@/features/auth/reset-password'

export const Route = createFileRoute('/(auth)/reset-password')({
  beforeLoad: () => {
    const { status } = useAuthStore.getState()
    if (status === 'authenticated') {
      throw redirect({ to: '/' })
    }
  },
  component: ResetPassword,
})
